import axiosClient from '../configs/axios';

class InwardService {
    // Get list 
   async getCylinderInwardList(params) {
    try {
        const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        

        const unit_id = userInfo?.depot_id || userInfo?.plant_id ;

        const response = await axiosClient.get(
            `/cyl-inward/list?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}&unit_id=${unit_id}`
        );
        return response.data;
    } catch (error) {
        throw error;
    }
}





    // GET DEPOT
async getInwardRealteddepotList(depot_id) {
        try {
            const response = await axiosClient.get(
                `/delivery-challan/customdepot?depot_id=${depot_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }





    // Get customer 
    async getInwardCustomerList(depot_id) {
        try {
            const response = await axiosClient.get(
                `/cyl-inward/customcustomer?depot_id=${depot_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get customer ECR
    async getCustomerECR(cust_id) {
        try {
            const response = await axiosClient.get(
                `/cyl-inward/customerecr?cust_id=${cust_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }


 async getsalesreturn({ page, size, searchKey, cust_id = "" }) {
    try {
        const queryParams = new URLSearchParams({
            page,
            size,
            searchKey,
            ...(cust_id && { cust_id: cust_id })
        });
        const response = await axiosClient.get(
            `/cyl-inward/challanSalesReturn?${queryParams.toString()}`
        );
        return response.data;
    } catch (error) {
        console.error('Error in getsalesreturn:', error.message);
        throw error;
    }
}

    // Get customer ECR Cylinders
    async getCustomerECRCylinder(entry_no) {
        try {
            const response = await axiosClient.get(
                `/cyl-inward/customerecrCylinder?entry_no=${entry_no}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

      async getCustomerDCno (depot_id){
        try {

            const response = await axiosClient.get(
                `/cyl-inward/relateddc?depot_id=${depot_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

        async getCustomerEmptyno (depot_id, from_depot_id){
        try {
            const response = await axiosClient.get(
                `/cyl-inward/relatedempty?depot_id=${depot_id}${from_depot_id ? `&from_depot_id=${from_depot_id}` : ''}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
// GET CYL FORM DC EMPTY
async getChallanCylinderDetails(challan_no, challan_type) {
    const url = `/cyl-inward/challancylinder?challan_no=${encodeURIComponent(challan_no)}&challan_type=${encodeURIComponent(challan_type)}`;
    console.log("Calling API →", url);
    try {
        const response = await axiosClient.get(url);
        console.log("API success:", response.data);
        return response.data;
    } catch (error) {
        console.error("API failed with:", error.response?.data || error.message);
        throw error;
    }
}






    // Add 
    async addCylinderInward(data) {
        try {
            const response = await axiosClient.post('/cyl-inward/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteCylinderInward(data) {
        try {
            const response = await axiosClient.put(`/cyl-inward/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new InwardService(); 